// extracted by mini-css-extract-plugin
export default {"f":"_367a89e0c8","main":"_312937f751","btn":"_891523f4e5","w":"_0df7ffafbb","h":"_57db2f01c2","lh25":"e5d271c2ba","wb":"_9dec5a50bb","b":"_8228e42242","bx":"_98d5cde9d6"};